import React from 'react';
import Card from '../base/Card';
import Button from '../base/Button';
import './PlaceholderStyles.css';

function CommunityPlaceholder() {
  return (
    <div className="placeholder-container">
      <Card className="placeholder-card feature-placeholder">
        <div className="placeholder-icon">👥</div>
        <h2 className="placeholder-title title-1">Community</h2>
        <p className="placeholder-description body-text">
          Connect with friends, share your progress, and stay motivated together.
          Build accountability partnerships and celebrate each other's wins.
        </p>
        <div className="placeholder-features">
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Friend connections</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Shared milestones</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Friendly competitions</span>
          </div>
        </div>
        <div className="placeholder-actions">
          <Button variant="primary" showArrow disabled>
            Find Friends
          </Button>
        </div>
        <p className="placeholder-note caption">
          Ready for implementation. Build your community features here.
        </p>
      </Card>
    </div>
  );
}

export default CommunityPlaceholder;








